var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '../../styled';
import * as Icons from '../icons';
import Text from '../text';
import tag from '../../themes/tag';
const Container = styled.div `
  display: inline-block;
  padding: ${({ theme, size }) => theme.tag.types[size].containerPadding};
  background-color: ${({ theme, bgColor }) => theme.colors[bgColor]};
  border-radius: 6px;
  line-height: 0;
  ${({ borderColor, theme }) => borderColor && `border: 1px solid ${theme.colors[borderColor]}`};
  ${({ hoverColor, theme }) => hoverColor &&
    `
    cursor: pointer;
    &:hover {
      background-color: ${theme.colors[hoverColor]}};
    }`};
`;
const TagContainer = styled.div `
  display: inline-block;
`;
const Wrapper = styled.div `
  display: flex;
  align-items: center;
  line-height: 0;
  border-radius: 6px;
  background-color: ${({ theme, bgColor }) => theme.colors[bgColor]};
  ${({ borderColor, theme }) => borderColor && `border: 1px solid ${theme.colors[borderColor]}`};
  ${({ hoverColor, theme }) => hoverColor &&
    `
    cursor: pointer;
    &:hover {
      background-color: ${theme.colors[hoverColor]}};
  }`};
`;
const TextWrapper = styled.div `
  word-break: break-word;
  display: flex;
  align-items: center;
`;
const IconWrapper = styled.div `
  margin-right: 0.5rem;
`;
const LabelWrapper = styled.div `
  padding: ${({ theme, size }) => theme.tag.types[size].labelPadding};
`;
const CrossWrapper = styled.div `
  position: relative;
  padding: ${({ theme, size }) => theme.tag.types[size].buttonPadding};

  ::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  &:hover {
    cursor: pointer;
    > svg {
      fill: ${({ theme }) => theme.colors.INK_500};
    }
    ::before {
      opacity: 0.05;
      background-color: ${({ theme }) => theme.colors.INK_800};
    }
  }
`;
const Tag = (_a) => {
    var { size, label, bgColor = 'INK_200', lang = 'en', onCloseClick, e2eTagId, e2eCloseButtonId, borderColor, hoverColor, Icon } = _a, restProps = __rest(_a, ["size", "label", "bgColor", "lang", "onCloseClick", "e2eTagId", "e2eCloseButtonId", "borderColor", "hoverColor", "Icon"]);
    const iconElement = Icon && (React.createElement(IconWrapper, null,
        React.createElement(Icon, { size: size })));
    const TextLabel = ({ icon }) => (React.createElement(TextWrapper, null,
        icon,
        React.createElement(Text, { fontType: tag.types[size].fontType, lang: lang, color: "INK_600" }, label)));
    return onCloseClick ? (React.createElement(TagContainer, Object.assign({ "data-e2e-id": e2eTagId }, restProps),
        React.createElement(Wrapper, { bgColor: bgColor, borderColor: borderColor, hoverColor: hoverColor },
            React.createElement(LabelWrapper, { size: size },
                React.createElement(TextLabel, { icon: iconElement })),
            React.createElement(CrossWrapper, { "data-e2e-id": e2eCloseButtonId, size: size, onClick: onCloseClick },
                React.createElement(Icons.Outline.Cross, { color: "INK_600", size: "XXSMALL" }))))) : (React.createElement(Container, Object.assign({ "data-e2e-id": e2eTagId, bgColor: bgColor, size: size, borderColor: borderColor, hoverColor: hoverColor }, restProps),
        React.createElement(TextLabel, { icon: iconElement })));
};
export default Tag;
//# sourceMappingURL=index.js.map